<template>
  <v-container class="overview-page" fluid>
    <v-row row wrap>
      <v-col cols="12" lg="5">
        <v-row>

          <v-col cols="12" sm="12">
            <v-card class="overview-card" elevation="0">
              <v-toolbar class="section-toolbar" flat>
                <div>
                  <div class="section-title">Profile note</div>
                  <div class="section-subtitle">Important internal information about this family</div>
                </div>
                <v-spacer></v-spacer>
                <v-btn v-if="checkRightStatus(36)" color="primary" depressed small @click="updateNote()">
                  <v-icon left size="17">mdi-content-save-outline</v-icon>Save
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-textarea v-model="note" outlined hide-details placeholder="Add a private note about this family…" rows="4"></v-textarea>
                <div v-if="checkRightStatus(37)" class="note-alert-setting">
                  <div><strong>Show as important</strong><span>Display this note at the top of the profile</span></div>
                  <v-switch v-if="getCustomer" v-model="getCustomer.alert" color="primary" inset hide-details @change="updateAlert" />
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12">
            <v-card class="overview-card" elevation="0">
              <v-card-text class="cash-setting">
                <div class="cash-icon"><v-icon color="primary">mdi-cash</v-icon></div>
                <div class="cash-copy"><strong>Cash payment preference</strong><span>Mark this family as normally paying school fees by cash.</span></div>
                <v-switch v-if="getCustomer" v-model="getCustomer.payingCash" color="primary" inset hide-details @change="updatePayingCash" />
              </v-card-text>
            </v-card>
          </v-col>


          <v-col cols="12" sm="12">

            <PaymentMethod ref="paymentMethodComponent" type="customer" :customer="getCustomer" />


            <!-- <v-select dense outlined :items="MerchantAccount" v-model="selectedMerchant" return-object item-text="name"
              label="Select Default Account"></v-select> -->


          </v-col>

          <!-- <v-col cols="12" sm="12">

            <v-card outlined>
              <v-toolbar dense flat color="grey lighten-3">
                <v-toolbar-title>
                  Stripe
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn fab x-small dark color="pink" @click="editStripe"><v-icon>mdi-pencil-outline</v-icon></v-btn>
              </v-toolbar>
              <v-card-text v-if="!getCustomer.stripeId">
                <div class="text-center">
                  <v-btn color="info" @click="attachStripeId" block>Attach Stripe ID</v-btn>
                </div>
              </v-card-text>
              <v-card-text v-else>
                <div class="text-center">
                  {{ getCustomer.stripeId }}
                </div>
              </v-card-text>
            </v-card>
          </v-col> -->
          <!-- <v-col cols="12" sm="12" v-if="getCustomer.mohidId">
            <v-card outlined>
              <v-toolbar dense flat color="grey lighten-3">
                <v-toolbar-title>
                  Mohid
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <div class="text-center">
                  <a :href="`https://us.mohid.co/ny/newyork/muhammadimasjid/masjid/admin/donation/consolidation/${getCustomer.mohidId}`"
                    target="_blank">View Consolidation</a>
                </div>

              </v-card-text>
            </v-card>
          </v-col> -->

          <!-- <v-col cols="12" sm="12" v-if="!getCustomer.mohidId">
            <v-card outlined>
              <v-toolbar dense flat color="grey lighten-3">
                <v-toolbar-title>
                  Mohid
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <div class="text-center">
                  <v-btn color="brown darken-1" dark block @click="attachMohid">Attach Mohid ID</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col> -->
          <!-- <v-col cols="12" sm="12">
            <PaymentPie :CustomerId="getCustomer.id"/>
          </v-col> -->
        </v-row>
      </v-col>
      <v-col cols="12" lg="7">
        <Comment :RelationId="getCustomer" :TypeId="1" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import customerService from "../service";
import stripeService from "@/modules/Stripe/service.js";
const Comment = () => import("@/modules/Comment/components/List");

import PaymentMethod from "@/modules/PaymentMethod/components/List.vue"
// import merchantService from "@/modules/Merchant/service.js";


// import SaleRep from "@/modules/User/components/AutoComplete.vue"
// import PaymentPie from "@/modules/Payment/Chart/PaymentMethodPie";

export default {
  name: "customer-dashbaord",
  data() {
    return {
      stripeCustomer: null,
      isLoading: false,
      loading: false,
      note: null,
      selectedUser: null,
    };
  },
  computed: {
    ...mapGetters("customer", ["getCustomer"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus", 'currentBusiness']),
  },
  components: {
    // CreditCard,
    Comment,
    // CreditCard,
    PaymentMethod,
    // SaleRep
  },
  watch: {

    getCustomer: {
      immediate: true,
      async handler(val) {
        
        this.note = val.note;
        
        if (this.$refs.paymentMethodComponent) {
          this.$refs.paymentMethodComponent.reload();
        }
      },
    },
  },
  methods: {
    ...mapActions("customer", ["setCustomer"]),
    async reload() {
      this.isLoading = true
      await this.setCustomer(this.getCustomer.id)
      // await this.getDonationCategoryList()
      // this.getCard()

    },
    markDefaultCard(card) {
      stripeService.changeDefaultCard({
        customer_id: this.getCustomer.stripeId,
        default_source: card.id
      }).then(result => {
        console.log('result', result)
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "success",
            title: "Card Marked Default",
          });
        this.reload()
      })
    },

    // getCard() {
    //   if (this.getCustomer && this.getCustomer.stripeId) {
    //     stripeService.getCustomerById({ customer_id: this.getCustomer.stripeId })
    //       .then((response) => {

    //         this.stripeCustomer = response.data
    //         return stripeService.getAllCard({ customer_id: this.getCustomer.stripeId })
    //           .then((response) => {
    //             console.log('card list', response)
    //             this.cards = response.data
    //             this.isLoading = false
    //           })
    //       })

    //   }
    // },
    // editStripe() {
    //   this.$swal.fire({
    //     title: 'Enter New Stipe ID',
    //     input: 'text',
    //     inputAttributes: {
    //       autocapitalize: 'off'
    //     },
    //     showCancelButton: true,
    //     confirmButtonText: 'Save',
    //     showLoaderOnConfirm: true,
    //     preConfirm: (value) => {
    //       return stripeService.getCustomerById({ customer_id: value })
    //         .then(() => {
    //           // console.log('dklfjdlkf', response)
    //           return customerService.update(this.getCustomer.id, { stripeId: value }).then(response => {

    //             this.getCard()
    //             return response.data
    //           })
    //         })
    //         .catch(error => {
    //           console.log('error', error)
    //           this.$swal.showValidationMessage(
    //             `Request failed: ${error.data.message}`
    //           )
    //         })
    //       // return fetch(`//api.github.com/users/${login}`)
    //       //   .then(response => {
    //       //     if (!response.ok) {
    //       //       throw new Error(response.statusText)
    //       //     }
    //       //     return response.json()
    //       //   })
    //       //   .catch(error => {
    //       //     this.$swal.showValidationMessage(
    //       //       `Request failed: ${error}`
    //       //     )
    //       //   })
    //     },
    //     allowOutsideClick: () => !this.$swal.isLoading()
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.$swal.fire({
    //         title: `${result.value.login}'s avatar`,
    //         imageUrl: result.value.avatar_url
    //       })
    //     }
    //   })
    // },
    // attachStripeId() {
    //   this.$swal.fire({
    //     title: 'Enter Stripe ID',
    //     input: 'text',
    //     inputAttributes: {
    //       autocapitalize: 'off'
    //     },
    //     showCancelButton: true,
    //     confirmButtonText: 'Submit',
    //     showLoaderOnConfirm: true,
    //     preConfirm: (stripeId) => {
    //       console.log('config', stripeId)
    //       customerService.update(this.getCustomer.id, { stripeId: stripeId }).then(response => {
    //         console.log('response', response)
    //         if (!response.code === '000000') {
    //           throw new Error(response.statusText)
    //         }

    //         this.getCustomerData()
    //         return response
    //       })
    //         .catch(error => {
    //           this.$swal.showValidationMessage(
    //             `Request failed: ${error}`
    //           )
    //         })
    //     },
    //     allowOutsideClick: () => !this.$swal.isLoading()
    //   }).then((result) => {
    //     console.log('resultresultresult', result)
    //     if (result.value) {
    //       this.$swal
    //         .mixin({
    //           toast: true,
    //           position: "top-end",
    //           showConfirmButton: false,
    //           timer: 3000,
    //         })
    //         .fire({
    //           icon: "success",
    //           title: "Stripe Id Set",
    //         });

    //     }
    //   })
    // },
    // attachMohid() {
    //   this.$swal.fire({
    //     title: 'Enter Mohid ID',
    //     input: 'number',
    //     inputAttributes: {
    //       autocapitalize: 'off'
    //     },
    //     showCancelButton: true,
    //     confirmButtonText: 'Submit',
    //     showLoaderOnConfirm: true,
    //     preConfirm: (mohidId) => {
    //       console.log('config', mohidId)
    //       customerService.update(this.getCustomer.id, { mohidId: mohidId }).then(response => {
    //         console.log('response', response)
    //         if (!response.code === '000000') {
    //           throw new Error(response.statusText)
    //         }

    //         this.getCustomerData()
    //         return response
    //       })
    //         .catch(error => {
    //           this.$swal.showValidationMessage(
    //             `Request failed: ${error}`
    //           )
    //         })
    //     },
    //     allowOutsideClick: () => !this.$swal.isLoading()
    //   }).then((result) => {
    //     console.log('resultresultresult', result)
    //     if (result.value) {
    //       this.$swal
    //         .mixin({
    //           toast: true,
    //           position: "top-end",
    //           showConfirmButton: false,
    //           timer: 3000,
    //         })
    //         .fire({
    //           icon: "success",
    //           title: "Mohid Id Set",
    //         });

    //     }
    //   })
    // },
    async getCustomerData() {

      this.$Progress.start();

      await this.setCustomer(this.getCustomer.id).then(result => {
        console.log('result', result)
        this.$forceUpdate();
      }).catch(err => {
        console.log('err', err)
      })

      // this.setPageTitle(this.getCustomer.name);
      // console.log("getCustomer", this.getCustomer);
      this.$Progress.finish();
    },
    test(val) {
      console.log(val)
    },
    updateNote() {
      let data = {
        note: this.note,
      };
      this.updateCustomer(data);
    },
    updateAlert(val) {
      let data = {
        alert: typeof val === "boolean" ? val : val.value,
      };
      this.updateCustomer(data);
    },
    updatePayingCash(val) {
      let data = {
        payingCash: typeof val === "boolean" ? val : val.value,
      };
      this.updateCustomer(data);
    },
    updateSaleman(val) {
      let data = {
        SalesRepUserId: val.id
      };
      this.updateCustomer(data);
    },
    updateCustomer(data) {
      return customerService.update(this.getCustomer.id, data).then((result) => {
        console.log('result', result)
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "success",
            title: "Update Successfully",
          });
        this.setCustomer(this.getCustomer.id);
      });
    },
  },
};
</script>

<style scoped>
.overview-page { padding: 18px; background: #f8faf8; }
.overview-card { border: 1px solid #e3e9e3; border-radius: 11px !important; overflow: hidden; }
.section-toolbar { height: auto !important; padding: 15px 17px; border-bottom: 1px solid #edf0ed; }
.section-toolbar ::v-deep .v-toolbar__content { height: auto !important; padding: 0; }
.section-title { color: #28362c; font-size: 14px; font-weight: 750; }
.section-subtitle { margin-top: 2px; color: #879388; font-size: 10px; }
.section-toolbar .v-btn { border-radius: 7px; text-transform: none; letter-spacing: 0; }
.overview-card ::v-deep .v-text-field__slot textarea { font-size: 13px; line-height: 1.55; }
.note-alert-setting { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-top: 14px; padding-top: 13px; border-top: 1px solid #edf0ed; }
.note-alert-setting div { display: flex; flex-direction: column; }
.note-alert-setting strong, .cash-copy strong { color: #39473d; font-size: 12px; }
.note-alert-setting span, .cash-copy span { margin-top: 2px; color: #89948a; font-size: 10px; }
.note-alert-setting .v-input--switch, .cash-setting .v-input--switch { margin: 0; padding: 0; }
.cash-setting { display: flex; align-items: center; gap: 13px; padding: 16px 18px; }
.cash-icon { display: flex; align-items: center; justify-content: center; flex: 0 0 40px; width: 40px; height: 40px; border-radius: 10px; background: #eaf6eb; }
.cash-copy { display: flex; min-width: 0; flex: 1; flex-direction: column; }
@media (max-width: 599px) {
  .overview-page { padding: 10px; }
  .section-subtitle { max-width: 210px; }
  .cash-setting { align-items: flex-start; }
}
</style>
